import axios from 'axios'

const getUuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
// 获取token
const getToken = () => {
  return window.$CCDK.CCToken.getToken("communityToken","communityToken");
}

/**需要在请求头加token的接口 */
const encryptList = ["/user/detailUserInfo", "/user/sendBindPhoneVerifyCode", "/user/bindPhone", "/user/bindPrivateAccount","/user/unbindAccount",]

const service = axios.create({
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
})

service.interceptors.request.use(
  config => {
    config.headers.requestId = getUuid()
    encryptList.forEach(item => {
      if (config.url.indexOf(item) > -1) {
        config.headers.accessToken = getToken()
      }
    })
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const code = response.data.code || 200
    if (code !== 200) {
      return Promise.reject(response.data.msg == null ? '未知异常' : response.data.msg)
    } else {
      return response.data
    }
  },
  error => {
    return Promise.reject(error)
  }
)
const formateData = data => {
  return {
    head: {
      versionNum: 'v1.2.1',
      versionType: 'public'
    },
    body: {
      ...data
    }
  }
}
export default {
  getFormat: (url, data = {}, responseType = '') => {
    return service({
      url: url,
      method: 'get',
      params: formateData(data),
      responseType: responseType
    })
  },
  postFormat: (url, data = {}, responseType = '') => {
    return service({
      url: url,
      method: 'post',
      data: formateData(data),
      responseType: responseType
    })
  },
  post: (url, data = {}) => {
    return service({
      url: url,
      method: 'post',
      data: data,
    })
  },
  get: (url, data = {}) => {
    return service({
      url: url,
      method: 'get',
      params: data
    })
  },
}
